export const UTM_MARKS = {
  source: 'utm_source',
  campaign: 'utm_campaign',
  medium: 'utm_medium',
  term: 'utm_term',
  content: 'utm_content',
} as const;

export const UTM_FB_MAP = {
  utm_source: 'UtmSource',
  utm_medium: 'UtmMedium',
  utm_campaign: 'UtmCampaign',
  utm_term: 'UtmTerm',
  utm_content: 'UtmContent',
} as const;

export const UTM_COOKIE_MAP = {
  [UTM_MARKS.source]: 'utmcsr',
  [UTM_MARKS.campaign]: 'utmccn',
  [UTM_MARKS.medium]: 'utmcmd',
  [UTM_MARKS.term]: 'utmctr',
  [UTM_MARKS.content]: 'utmcct',
} as const;

export const UTM_MEDIUM_VALUES = {
  PAID_TRAFFIC: [
    'olv',
    'cpc_out',
    'cpm_out',
    'tv_out',
    'cpc',
    'cpm',
    'display',
    'bloggers',
    'smm_cpc',
    'smm_paid',
    'cpc_paid',
    'cpm_paid',
  ],
  ORGANIC_TRAFFIC: ['organic', '(none)'],
};
